import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12114850"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bom_inner_left"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "addDesc m-auto"
}, "添加AI助手", -1));
const _hoisted_3 = {
  class: "bom_left_bom"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "ellipsis"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'slideLeft',
  props: ['roleList', 'select_role_ac'],
  emits: ['changeAc', 'editClick'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    // import robote from '@/assets/images/leftSlide/robote.png'
    // const roleList = reactive([
    //   { avatar: robote, name: 'Copilot' },
    //   { avatar: robote, name: 'Copilot' },
    //   { avatar: robote, name: 'Copilot' },
    //   { avatar: robote, name: 'Copilot' }
    // ])
    const edit = () => {
      emits('editClick', true);
    };
    // const select_role_ac = ref(0)
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "bom_left_top cursor-p text-center"
      }, [_createElementVNode("div", {
        class: "add1 m-auto",
        onClick: edit
      }), _hoisted_2]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.roleList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["avatarList cursor-p", {
            ac_bg: index == __props.select_role_ac
          }]),
          key: index,
          onClick: $event => emits('changeAc', index)
        }, [_createElementVNode("div", {
          class: _normalizeClass(["innerlist d-flex", {
            leftAc: index == __props.select_role_ac
          }])
        }, [_hoisted_5, _createElementVNode("img", {
          src: item.digitalManImg,
          alt: ""
        }, null, 8, _hoisted_6), _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1)], 2)], 10, _hoisted_4);
      }), 128))])]);
    };
  }
});